module.exports = "/hwa/_next/static/images/bin-collection-01b874636ece6f749b956fd4bf891ee2.png";